// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { colorProfileValidationObject } from "@dashboardApi/apis/engagementInAppMessageColorProfilesId";

export const isEngagementInAppMessageColorProfilesDefaultResult = objectOf({
  color_profile: colorProfileValidationObject,
  css_profile: colorProfileValidationObject,
});
